export default __webpack_public_path__ + "static/media/background.e1d883b0.png";